import { route } from "preact-router";

export let redirect = route;
export const setRedirectFnc = (fnc) => redirect = fnc;
